const ErrorUtil = {
  pushError(pageError: boolean, error: Error): string {
    const reference = `tx:${window.TeliaRum?.sendError(error)}`;
    window.dataLayer?.push({
      event: 'NONIEvent',
      interactionType: 'Error',
      elementType: pageError ? 'Page error' : 'Component error',
      elementId: reference
    });
    return reference;
  },

  pushErrorToGrafanaAndLog(error: Error | string): void {
    window.TeliaRum?.sendError(error);
    console.error(error);
  },

  dispatchErrorEvent(error: Error): void {
    window.dispatchEvent(new ErrorEvent('error', error));
  }
};

export default ErrorUtil;
